import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const myRouter: Array<RouteRecordRaw> = [
    {
        path: '/data-management',
        name: '公司资料管理',
        component: Layout,
        meta: { title: '公司资料管理', icon: 'icon-setting', alwaysShow: true },
        children: [
            {
                path: 'process_rules',
                name: '流程及规则',
                component: () => import('@/views/data-management/CompanyQualification.vue'),
                meta: { title: '流程及规则',grade:1 }
            },
            {
                path: 'agreement_quotation',
                name: '协议&报价',
                component: () => import('@/views/data-management/CompanyQualification.vue'),
                meta: { title: '协议&报价',grade:2 }
            },
            {
                path: 'sales_proposal',
                name: '销售标书',
                component: () => import('@/views/data-management/CompanyQualification.vue'),
                meta: { title: '销售标书',grade:3 }
            },
            {
                path: 'TEMPLATES',
                name: '报表模板',
                component: () => import('@/views/data-management/CompanyQualification.vue'),
                meta: { title: '报表模板',grade:4 }
            },
            {
                path: 'company-qualification',
                name: '公司资质',
                component: () => import('@/views/data-management/CompanyQualification.vue'),
                meta: { title: '公司资质',grade:5 }
            },
            {
                path: 'publicity_material',
                name: '宣传资料',
                component: () => import('@/views/data-management/CompanyQualification.vue'),
                meta: { title: '宣传资料',grade:6 }
            },
            {
                path: 'others',
                name: '其他资料',
                component: () => import('@/views/data-management/CompanyQualification.vue'),
                meta: { title: '其他资料',grade:7 }
            },
            {
                path: 'log',
                name: '日志',
                component: () => import('@/views/data-management/CompanyMaterialLog.vue'),
                meta: { title: '日志' }
            },
            
        ]
    }
]

export default myRouter